<template>
    <div>
        <div
            class="innerBox"
            style="
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 7.5px 10px;
            "
        >
            <button
                class="btn"
                style="
                    font-size: 16px;
                    color: #6c6c6c;
                    font-weight: bold;
                    padding: 4px;
                "
                @click="$router.go(-1)"
            >
                <i class="fas fa-angle-left mr-2"></i>Back
            </button>
            <p
                class="mb-0"
                style="font-size: 16px; color: #b9b9b9; font-weight: 600"
            >
                | Defect >> Detail Report <i class="fas fa-angle-right"></i>
            </p>
            <p
                class="mb-0 ml-1"
                style="font-size: 16px; color: #4b4b4b; font-weight: bold"
            >
                {{ defectDetail.nopolisi }}
            </p>
        </div>

        <div class="innerBox mt-4">
            <div class="row ml-2">
                <div class="col-5">
                    <div class="row">
                        <div class="col">
                            <label class="form-label" style="color: #bcbcbc;">Nopol</label>
                        </div>
                        <div class="col">{{ defectDetail.nopolisi }}</div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label" style="color: #bcbcbc;">Ekspedisi</label>
                        </div>
                        <div class="col">{{ defectDetail.ekspedisi_name }}</div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label" style="color: #bcbcbc;">Driver</label>
                        </div>
                        <div class="col">{{ defectDetail.sopir }}</div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label" style="color: #bcbcbc;">Gudang Tujuan</label>
                        </div>
                        <div class="col">{{ defectDetail.kodegudang }}</div>
                    </div>
                </div>
                <div class="col-5">
                    <div class="row">
                        <div class="col">
                            <label class="form-label" style="color: #bcbcbc;">Tanggal Muat</label>
                        </div>
                        <div class="col">{{ defectDetail.tglmuat }}</div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label" style="color: #bcbcbc;">Tanggal LKU</label>
                        </div>
                        <div class="col">{{ defectDetail.tgllku  }}</div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label" style="color: #bcbcbc;">Persentasi Defect (%)</label>
                        </div>
                        <div class="col" style="color: #ff5353">{{ defectDetail.persentase_rusak }}%</div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <label class="form-label" style="color: #bcbcbc;">Muatan</label>
                        </div>
                        <div class="col">{{ defectDetail.total_angkut }}</div>
                    </div>
                </div>
                <div class="col-1"></div>
                <div class="col-1"></div>
            </div>

            <div class="col-5 mt-3">
                <label class="details-title2">Part Defect List</label>
            </div>

            <div class="col-5">
                <label class="details-content2">Total Defect : </label>
                <label class="details-content2">{{
                    defectDetail.total_rusak
                }}</label>
            </div>

            <div class="row">
                <table class="table tms-table">
                    <thead>
                        <tr>
                            <th style="color: #bcbcbc;">Nama Part</th>
                            <th style="color: #bcbcbc;">Nomor Mesin</th>
                            <th style="color: #bcbcbc;">Nomor Rangka</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="list in listDefectDetail" :key="list.id">
                            <td>{{ list.partname }}</td>
                            <td>{{ list.nomermesin }}</td>
                            <td>{{ list.nomorrangka }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import qs from "qs";
export default {
    metaInfo: {
        title: "Defect",
    },
    data() {
        return {
            defectDetail: {},
            selectedDate: null,
            listDefectDetail: [],
            selectedSearchResult: null,
            searchQuery: "",
            searchResults: [{ value: "Pilih Nopol" }, { value: "Pilih Nopol" }],
        };
    },
    mounted() {
        this.defectDetail = JSON.parse(this.$store.state.defectData);
        console.log('testing', JSON.parse(this.$store.state.defectData));
        const objFilter = {
            nopol: this.defectDetail.nopolisi,
            tgllku: this.defectDetail.tgllku
        }
        if (!this.defectDetail) {
            this.goBack();
        } else {
            this.$http.get(`/api/reports/defact/list-detail-part-defect?${qs.stringify(objFilter, {
             skipNulls: true,
             arrayFormat: "comma",
            })}`).then(resp => {
                this.listDefectDetail = resp.data.data;
            })
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style scoped>
.innerBox {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
}

.chart {
    background-color: white;
    border-radius: 8px;
    box-shadow: 0px 3px 10px #0000000f;
    padding: 20px;
    align-items: center;
}

.elegant--sub-title {
    font-size: 18px;
    font-weight: 500;
    color: #4d4d4d;
}

/* .center {
          padding: 50px 20px;
          display: flexbox;
          flex-direction: column;
          align-items: center;
          justify-content: center;
      } */

.stats--icon {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
}

.table td,
.table th {
    text-align: center;
}

.news-image-1 img {
    max-width: 100%; /* To make the image smaller and responsive */
}

.news-title-1 {
    text-align: left; /* To position the news-title on the top right */
}

.news-content-1 {
    text-align: left; /* To position the news-content on the bottom right */
}

.search-container {
    display: flex;
    align-items: center;
}

.dropdown-container {
    flex: 1;
    margin-right: 10px;
}

.searchbar-container {
    flex: 2;
}

.dropdown {
    width: 100%;
}

.searchbar {
    width: 50%;
    padding: 5px;
}

.details-title {
    color: #bcbcbc;
    font-size: 16px;
}

.details-content {
    color: #000000;
    font-size: 24px;
}

.details-content-red {
    color: #ff5353;
    font-size: 24px;
}

.details-title2 {
    color: #000000;
    font-size: 16px;
    font-weight: bolder;
}

.details-content2 {
    color: #000000;
    font-size: 14px;
}
</style>
